import "rxjs/add/operator/map";

import { Types, Creators } from "../reducer";

import * as firebase from 'firebase';

const completeRegistration = action =>
  firebase
    .database()
    .ref(`complete/${action.id}`)
    .set({ status: "pending" })
    .then(() => {
      localStorage.removeItem("currentRegistrationId");
      return Creators.registrationCompleted();
    });

export default (action$, store) =>
  action$.ofType(Types.COMPLETE_REGISTRATION).mergeMap(completeRegistration);



// WEBPACK FOOTER //
// ./src/registration/epics/completeRegistration.js